import { DragEvent } from "react";

export const onNodeDragStart = ({ dataTransfer }: DragEvent, nodeName: string) => {
  dataTransfer.setData("application/reactflow", nodeName);
  dataTransfer.effectAllowed = "move";
};
